var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00043 -0.000244141C1.02266 -0.000244141 0.222656 0.799756 0.222656 1.77753C0.222656 2.75531 1.02266 3.55531 2.00043 3.55531C2.97821 3.55531 3.77821 2.75531 3.77821 1.77753C3.77821 0.799756 2.97821 -0.000244141 2.00043 -0.000244141ZM2.00043 12.4442C1.02266 12.4442 0.222656 13.2442 0.222656 14.222C0.222656 15.1998 1.02266 15.9998 2.00043 15.9998C2.97821 15.9998 3.77821 15.1998 3.77821 14.222C3.77821 13.2442 2.97821 12.4442 2.00043 12.4442ZM2.00043 6.22198C1.02266 6.22198 0.222656 7.02198 0.222656 7.99976C0.222656 8.97753 1.02266 9.77753 2.00043 9.77753C2.97821 9.77753 3.77821 8.97753 3.77821 7.99976C3.77821 7.02198 2.97821 6.22198 2.00043 6.22198Z",
    fill: "#8898A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.4717c2060cad08b25e4b37fd17eae51d.svg";
export { ForwardRef as ReactComponent };